module.exports = __webpack_public_path__ + "static/media/logo.d04876c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Guest/Home/images/logo.png
// module id = 174
// module chunks = 0